import PageLayout from "@/components/feature/PageLayout";
import HeroBanner from "@/pages/home/components/HeroBanner";
import CategoryEntries from "@/pages/home/components/CategoryEntries";
import LatestRow from "@/pages/home/components/LatestRow";
import HotGrid from "@/pages/home/components/HotGrid";
import IntroSection from "@/pages/home/components/IntroSection";

export default function Home() {
  return (
    <PageLayout>
      <div>
        <HeroBanner />
        <CategoryEntries />
        <LatestRow />
        <HotGrid />
        <IntroSection />
      </div>
    </PageLayout>
  );
}